import { Component, OnInit } from '@angular/core';
import { PointsService} from '../../services/points.service';
import { CommonService } from '../../services/common.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-pico-times',
  templateUrl: './pico-times.component.html',
  styleUrls: ['./pico-times.component.css']
})
export class PicoTimesComponent implements OnInit {

  temporalTime: any = {}
  times: any = []
  constructor(
    private pointsService: PointsService,
    private commonService: CommonService,

  ) { }

  ngOnInit() {
    // this.temporalTime.hour = 8;
    // this.temporalTime.minute = 0;
    this.temporalTime.startTime = "08:00 am";
    this.temporalTime.endingTime = "12:00 am";
    this.temporalTime.user_account = this.commonService.getUserName();
    this.getPicoTimes()
  }

  getPicoTimes(){
    this.pointsService.getPicoTimes(this.commonService.getUserName()).then(response => {
      console.log(response)
      this.times = []
      for(var i in response){
        this.times.push(response[i])
      }
    });
  }

  addTimes(){
    if(new Date ('1/1/1999 ' + this.temporalTime.startTime) > new Date ('1/1/1999 ' + this.temporalTime.endingTime)){
      swal({
        title: 'La Hora Inicial deber ser menor a la Hora Final',
        text: '',
        type: 'error',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Aceptar',
      })
      return 
    }

    var that = this;

    this.pointsService.savePicoTime(this.temporalTime).then(response => {
    that.getPicoTimes()
    this.temporalTime = {startTime : "08:00 am", endingTime : "12:00 am", user_account : this.commonService.getUserName()}

    });
  }

  deletePicoTime(id){
    var that = this;

    swal({
      title: '¿Esta seguro de borrar el Registro Seleccionado?',
      text: '',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#ff5370',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No'
    }).then(function (s) {
      that.pointsService.deletePicoTime(id).then(response => {
        that.getPicoTimes()
      });
    }).catch(swal.noop);

  }
}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/components/pico-times/pico-times.component.ts